/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import reportWebVitals from './reportWebVitals';

if (
  (import.meta.env.NODE_ENV === 'development' || import.meta.env.NODE_ENV === 'test') &&
  localStorage.getItem('isContentManagementV2Enabled') === 'true' &&
  localStorage.getItem('isMockLabBackendEnabled') === 'true'
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser');
  worker.start({
    quiet: true,
    onUnhandledRequest: 'bypass',
  });
}

const profile = localStorage.getItem('profile');
if (profile) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const _hsq = (window as any)._hsq || [];
  _hsq.push([
    'identify',
    {
      email: JSON.parse(profile).email,
    },
  ]);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
